import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode("價錢：HK$ " + _toDisplayString(Number(_ctx.order.totalPrice).toLocaleString()), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { fixed: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGroupedCanvasShapes(_ctx.order), (value, type) => {
              return (_openBlock(), _createBlock(_component_ion_list, { key: type }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", null, [
                            _createElementVNode("b", null, _toDisplayString(type) + _toDisplayString(value.totalPrice ? ` (HK$${value.totalPrice})` : ""), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.groupedShapes, (value, shapeId) => {
                    return (_openBlock(), _createBlock(_component_ion_item, { key: shapeId }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              style: {"object-fit":"contain"},
                              src: value.shapes[0].photoLink || value.shapes[0].photo
                            }, null, 8, _hoisted_1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, [
                              _createElementVNode("b", null, _toDisplayString(value.shapes.length) + " x " + _toDisplayString(value.shapes[0].name), 1)
                            ]),
                            _withDirectives(_createElementVNode("p", { style: {"white-space":"pre-line"} }, _toDisplayString(_ctx.order['名牌字']), 513), [
                              [_vShow, value.shapes[0].name == '木名牌']
                            ]),
                            _withDirectives(_createElementVNode("p", null, "總計：HK$" + _toDisplayString(value.totalPrice), 513), [
                              [_vShow, value.totalPrice != null]
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}